// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__kad2q","inputDescription":"styles_inputDescription__3KsBR"};